import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/nightCoaching/page',
    add:'/api-ir/bachelor/nightCoaching/add',
    update:'/api-ir/bachelor/nightCoaching/edit',
    info:'/api-ir/bachelor/nightCoaching/get/',
    del:'/api-ir/bachelor/nightCoaching/delete/',
    tjList:'/api-ir/bachelor/nightCoaching/pagesum',
    export:'/api-ir/bachelor/nightCoaching/export',
    tjExport:'/api-ir/bachelor/nightCoaching/sumExport',

    timeSetList:'/api-ir/bachelor/nightCoachingTime/page',
    timeSetAdd:'/api-ir/bachelor/nightCoachingTime/add',
    timeSetEdit:'/api-ir/bachelor/nightCoachingTime/edit',
    timeSetDel:'/api-ir/bachelor/nightCoachingTime/delete/',
    timeSetCurrent:'/api-ir/bachelor/nightCoachingTime/current'
}

export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function tjList (data) {
    return baseAPI.axiosData(api.tjList,'get',data)
}

export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}

export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}

export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}

export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}

export function exportTable (data) {
    return baseAPI.axiosData(api.export,'get',data)
}

export function exportTjTable (data) {
    return baseAPI.axiosData(api.tjExport,'get',data)
}



export function timeSetList (data) {
    return baseAPI.axiosData(api.timeSetList,'get',data)
}

export function timeSetAdd (data) {
    return baseAPI.axiosData(api.timeSetAdd,'post',data)
}

export function timeSetEdit (data) {
    return baseAPI.axiosData(api.timeSetEdit,'put',data)
}

export function timeSetDel (id) {
    return baseAPI.axiosData(api.timeSetDel+id,'delete')
}

export function timeSetCurrent (data) {
    return baseAPI.axiosData(api.timeSetCurrent,'get',data)
}